import React, {Fragment} from 'react';

import {MyProfileEnum, ServicesTaggingEnum} from 'main/analytics/gaTagsEnum';
import {
	CTAButtonFixed,
	EmptyState,
	ErrorState,
	PrintTemplateContainer,
	StyledGrid,
} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {SelectionFlowEnum} from 'presentation/constants';
import {useHostName, usePrint} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {useLocation, useNavigate} from 'react-router-dom';
import {useGetHealthCardQuery} from '../../queries/useGetHealthCardQuery';
import {CardDetails} from '../CardDetails';
import {HealthCard} from '../HealthCard';
import {PrintTemplate} from '../PrintTemplate';
import {StyledButton, StyledButtonContainer, StyledStack} from './styles';
import {LoadingState} from '../LoadingState';
import {HealthCardNotreDame} from '../HealthCardNotreDame';
import Icon from 'presentation/icons';

const {saveImage, empty, error} = translations['pt-br'].privateFlow.healthCard;
const {changeBeneficiary} = translations['pt-br'].commons;

function Content() {
	const {isTablet} = useMediaQueries();
	const navigate = useNavigate();
	const {pathname} = useLocation();
	const {data: healthCardData, refetch, isError, isLoading} = useGetHealthCardQuery();
	const {printRef, printContent, isPrinting} = usePrint('carteirinha');
	const {isNotredameSaude} = useHostName();

	const handleGoBeneficiariesSelection = () => {
		navigate(SelectionFlowEnum.BENEFICIARY_SELECTION, {
			state: {
				pathFrom: pathname,
			},
		});
	};

	const isEmpty = !healthCardData;

	const BUTTON_END_ICON = isPrinting ? <Loading size={24} color="inherit" /> : null;

	if (isLoading && !healthCardData) {
		return <LoadingState />;
	}

	if (isError) {
		return (
			<ErrorState
				title={error.title}
				description={error.description}
				handleRefresh={refetch}
			/>
		);
	}

	if (isEmpty) {
		return <EmptyState title={empty.title} description={empty.description} />;
	}

	return (
		<Fragment>
			<StyledGrid.Item sm={12} md={12} lg={6}>
				<StyledStack $isSingleItem={!!healthCardData}>
					{isNotredameSaude ? (
						<HealthCardNotreDame data={healthCardData} hiddenCopyIcon />
					) : (
						<HealthCard data={healthCardData} />
					)}
					<StyledButtonContainer>
						{isTablet && isNotredameSaude ? (
							<StyledButton
								onClick={handleGoBeneficiariesSelection}
								variant="text"
								fullWidth
								sx={{textDecoration: 'underline'}}
								data-tag-id={MyProfileEnum.CLICK_ALTERAR_BENEFICIARIO}
								endIcon={<Icon name="arrow-circle" size={16} />}>
								{changeBeneficiary}
							</StyledButton>
						) : (
							<StyledButton
								onClick={handleGoBeneficiariesSelection}
								variant="outlined"
								fullWidth
								data-tag-id={MyProfileEnum.CLICK_ALTERAR_BENEFICIARIO}>
								{changeBeneficiary}
							</StyledButton>
						)}
						{!isTablet ? (
							<StyledButton
								disabled={isPrinting}
								onClick={printContent}
								variant="outlined"
								endIcon={BUTTON_END_ICON}
								fullWidth
								data-tag-id={ServicesTaggingEnum.CLICK_SALVAR_IMAGEM_CARTEIRINHAS}>
								{saveImage}
							</StyledButton>
						) : null}
					</StyledButtonContainer>
				</StyledStack>
			</StyledGrid.Item>
			<StyledGrid.Item sm={12} md={12} lg={6}>
				<CardDetails data={healthCardData} />
			</StyledGrid.Item>

			{isTablet ? (
				<CTAButtonFixed.Root $isTablet={isTablet}>
					<CTAButtonFixed.Action
						disabled={isPrinting}
						onClick={printContent}
						variant="outlined"
						endIcon={BUTTON_END_ICON}
						fullWidth
						data-tag-id={ServicesTaggingEnum.CLICK_SALVAR_IMAGEM_CARTEIRINHAS}>
						{saveImage}
					</CTAButtonFixed.Action>
				</CTAButtonFixed.Root>
			) : null}

			<StyledGrid.Item sm={12} md={12} lg={12}>
				<PrintTemplateContainer printRef={printRef}>
					<PrintTemplate data={healthCardData} />
				</PrintTemplateContainer>
			</StyledGrid.Item>
		</Fragment>
	);
}

export {Content};
